module.exports = __webpack_public_path__ + "img/nodata.4b1f61dc.png";